import { compileAiQuestions, cureRulebookState, instructionLines, resolveActiveRules, resolveCaption, } from "@next-platform/packages-ts-types";
const questionCriteria = (question) => {
    if (question.type === "choice") {
        return Object.keys(question.criteria);
    }
    if (question.type === "score") {
        return question.criteria;
    }
    return undefined;
};
/** Prompt lines with the source meter id attached so views can tint chips per meter. */
export const instructionLinesWithMeterId = (active) => instructionLines(active).map((line) => ({
    ...line,
    meterId: line.key.startsWith("combined:") ? undefined : line.key.slice(0, line.key.indexOf(":")),
}));
/** Question id prefix before the first "." is the owning meter id (`<clock>.skip` → the clock meter). */
const questionMeterId = (questionId) => {
    const dotIndex = questionId.indexOf(".");
    return dotIndex === -1 ? questionId : questionId.slice(0, dotIndex);
};
/**
 * Everything the Editor evaluator preview needs for a definition: the compiled AI
 * questions grouped per meter, the initial cured state, and the active instruction set.
 * `values` (the playtest's current meters) fill meter tokens in AI conditions; the default state is used otherwise.
 */
export default function buildEvaluatorPreview({ definition, charName, userName = "User", values, }) {
    const defaultState = cureRulebookState(definition);
    const compiled = compileAiQuestions(definition, { charName, userName }, values ?? defaultState.values);
    const active = resolveActiveRules(definition, defaultState.values);
    const labelById = new Map(definition.meters.map((meter) => [meter.id, meter.label]));
    const groups = new Map();
    Object.entries(compiled.questions).forEach(([questionId, question]) => {
        const meterId = questionMeterId(questionId);
        const group = groups.get(meterId) ?? {
            meterId,
            meterLabel: labelById.get(meterId) ?? meterId,
            questions: [],
        };
        group.questions.push({
            id: questionId,
            type: question.type,
            instructions: question.instructions,
            criteria: questionCriteria(question),
        });
        groups.set(meterId, group);
    });
    const preview = {
        questionGroups: [...groups.values()],
        defaultState,
        instructions: instructionLinesWithMeterId(active),
    };
    const caption = resolveCaption(active);
    if (caption !== undefined) {
        preview.caption = caption;
    }
    return preview;
}
